import Script from 'next/script';

import { type AnalyticsEvent } from '../../config';
import { type AnalyticsProvider, ProviderId } from '../../model';

const YM_ID = Number(process.env.NEXT_PUBLIC_YM_COUNTER_ID);

const yandexProvider: AnalyticsProvider = {
  id: ProviderId.Yandex,

  track(event: AnalyticsEvent) {
    if (!window.ym) return;

    window.ym(YM_ID, 'reachGoal', event);
  },

  identify(userGroupId: string) {
    if (!window.ym) return;

    window.ym(YM_ID, 'userParams', {
      userGroupId,
    });
  },

  getScript() {
    return (
      <Script
        defer
        id="metrika-counter"
        type="text/javascript"
      >
        {`
           (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
           m[i].l=1*new Date();
           for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
           k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
           (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");


           ym(${YM_ID}, "init", {
             clickmap:true,
             trackLinks:true,
             accurateTrackBounce:true,
             webvisor:true,
             trackHash:true
           });
        `}
      </Script>
    );
  },
};

export default yandexProvider;
